var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRegisterSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55 0C24.6354 0 0 24.6354 0 55C0 85.3646 24.6354 110 55 110C85.3646 110 110 85.3646 110 55C110 24.6354 85.3646 0 55 0ZM83.3021 41.7083L50.9896 74.1354C49.9583 75.1667 48.4688 75.8542 46.9792 75.8542C45.4896 75.8542 44 75.2812 42.9688 74.1354L26.6979 57.8646C24.4062 55.5729 24.4062 52.0208 26.6979 49.7292C28.9896 47.4375 32.5417 47.4375 34.8333 49.7292L46.9792 61.875L75.2812 33.5729C77.5729 31.2812 81.125 31.2812 83.4167 33.5729C85.5938 35.8646 85.5938 39.4167 83.3021 41.7083Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegisterSuccess);
export default __webpack_public_path__ + "static/media/registerSuccess.d2495a262126d1aaf6c9d46c995c2512.svg";
export { ForwardRef as ReactComponent };